import { makeStyles } from "@material-ui/core";
import { ResponsiveLine } from '@nivo/line';
import { DashboardHeader } from "pages/admin/dashboard/components/general";
const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)'
  },
  chart: {
    width: '100%',
    height: '100%',
  }
}));

const data = [
  {
    "id": "month",
    "color": "#BEE0E9",
    "data": [
      {
        "x": "Jan",
        "y": 50
      },
      {
        "x": "Feb",
        "y": 15
      },
      {
        "x": "Mar",
        "y": 103
      },
      {
        "x": "Apr",
        "y": 51
      },
      {
        "x": "May",
        "y": 13
      },
      {
        "x": "June",
        "y": 63
      },
      {
        "x": "Jul",
        "y": 114
      },
      {
        "x": "Aug",
        "y": 170
      },
      {
        "x": "Sep",
        "y": 289
      },
      {
        "x": "Oct",
        "y": 253
      },
      {
        "x": "Nov",
        "y": 33
      },
      {
        "x": "Dec",
        "y": 62
      }
    ]
  },
]
const ResponsiveLineEndorsement = ({ data /* see data tab */ }) => (
  <ResponsiveLine
    data={data}
    margin={{ top: 30, right: 10, bottom: 30, left: 30 }}
    // yFormat=" >-.2f"
    animate={true}
    isInteractive={false}
    axisTop={null}
    axisRight={null}
    axisLeft={null}
    enableArea={true}
    enableGridX={false}
    enableGridY={false}

    // axisLeft={{
    //   tickValues: 6
    // }}
    enablePointLabel={true}
    colors={data.map(x => x.color)}
  // legends={
  //   [
  //     {
  //       anchor: 'bottom-right',
  //       direction: 'column',
  //       justify: false,
  //       translateX: 100,
  //       translateY: 0,
  //       itemsSpacing: 0,
  //       itemDirection: 'left-to-right',
  //       itemWidth: 80,
  //       itemHeight: 20,
  //       itemOpacity: 0.75,
  //       symbolSize: 12,
  //       symbolShape: 'circle',
  //       symbolBorderColor: 'rgba(0, 0, 0, .5)',
  //       effects: [
  //         {
  //           on: 'hover',
  //           style: {
  //             itemBackground: 'rgba(0, 0, 0, .03)',
  //             itemOpacity: 1
  //           }
  //         }
  //       ]
  //     }
  //   ]}
  />
)

function Endorsement() {
  const classes = useStyles();

  return (
    <>
      <div>
        <DashboardHeader title="Result of qualification endorsement" />
      </div>
      <div className={classes.wrapChart}>

        <ResponsiveLineEndorsement data={data} className={classes.chart} />
      </div>
    </>
  )
}


export default Endorsement;